module.exports = __webpack_public_path__ + "static/media/bio_image.aae283ca.png";